export default __webpack_public_path__ + "static/media/cross-circle-grey.30d54dfe.svg";